import { useCallback, useState } from "react";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { db } from "@/integrations/firebase/firestore";
import { logError } from "@/shared/services/ErrorReporting";

export function useCreateTenant() {
  const [isCreating, setIsCreating] = useState(false);

  const createTenant = useCallback(async (name: string): Promise<boolean> => {
    setIsCreating(true);
    const tenantId = uuidv4();
    try {
      await setDoc(doc(db, "tenants", tenantId), {
        id: tenantId,
        name: name.trim(),
        status: "ACTIVE",
        admin_uids: [],
        active_user_emails: [],
        assignment_history: [],
        created_at: serverTimestamp(),
      });
      return true;
    } catch (err) {
      logError(err as Error);
      return false;
    } finally {
      setIsCreating(false);
    }
  }, []);

  return { createTenant, isCreating };
}
